(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-collection-row"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-scroll-row')) {
    class HomeScrollRow extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.track = this.querySelector('[data-track]');
        this.prevButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');
        this.controls = this.querySelector('[data-controls]');
        if (!this.track) return;

        this.onPrev = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.onScroll = () => this.sync();
        this.prevButton?.addEventListener('click', this.onPrev);
        this.nextButton?.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.sync();
      }

      move(direction) {
        const card = this.track.querySelector('[data-card]');
        if (!card) return;
        const styles = getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 16;
        const amount = card.getBoundingClientRect().width + gap;
        this.track.scrollTo({
          left: this.track.scrollLeft + amount * direction,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      sync() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const overflows = max > 4;
        if (this.controls) this.controls.hidden = !overflows;
        if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 4;
        if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= max - 4;
      }

      disconnectedCallback() {
        this.ready = false;
        this.prevButton?.removeEventListener('click', this.onPrev);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.track?.removeEventListener('scroll', this.onScroll);
      }
    }

    customElements.define('home-scroll-row', HomeScrollRow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-focus-chips"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-focus-chips')) {
    class HomeFocusChips extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.button = this.querySelector('[data-more]');
        if (!this.button) return;
        this.onClick = () => {
          const open = this.classList.toggle('is-open');
          const moreLabel = this.button.dataset.moreLabel || '+ more';
          const lessLabel = this.button.dataset.lessLabel || 'Show less';
          this.button.textContent = open ? lessLabel : moreLabel;
          this.button.setAttribute('aria-expanded', open ? 'true' : 'false');
        };
        this.button.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.ready = false;
        this.button?.removeEventListener('click', this.onClick);
      }
    }

    customElements.define('home-focus-chips', HomeFocusChips);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-formula-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-formula-carousel')) {
    class HomeFormulaCarousel extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.track = this.querySelector('[data-track]');
        this.nextButton = this.querySelector('[data-next]');
        if (!this.track || !this.nextButton) return;
        this.onNext = () => {
          const card = this.track.querySelector('[data-card]');
          if (!card) return;
          const styles = getComputedStyle(this.track);
          const gap = parseFloat(styles.columnGap || styles.gap) || 16;
          const amount = card.getBoundingClientRect().width + gap;
          const max = this.track.scrollWidth - this.track.clientWidth - 4;
          const atEnd = this.track.scrollLeft >= max;
          this.track.scrollTo({
            left: atEnd ? 0 : this.track.scrollLeft + amount,
            behavior: 'smooth'
          });
        };
        this.nextButton.addEventListener('click', this.onNext);
      }

      disconnectedCallback() {
        this.ready = false;
        this.nextButton?.removeEventListener('click', this.onNext);
      }
    }

    customElements.define('home-formula-carousel', HomeFormulaCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-need-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-need-cards')) {
    class HomeNeedCards extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.track = this.querySelector('[data-track]');
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        if (!this.track || this.dots.length === 0) return;

        this.onScroll = () => this.syncDots();
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const card = this.track.children[Number(dot.dataset.index)];
            if (!card) return;
            const left =
              card.getBoundingClientRect().left -
              this.track.getBoundingClientRect().left +
              this.track.scrollLeft;
            this.track.scrollTo({ left, behavior: 'smooth' });
          });
        });
      }

      syncDots() {
        const trackRect = this.track.getBoundingClientRect();
        let index = 0;
        let best = Infinity;
        Array.from(this.track.children).forEach((card, i) => {
          const distance = Math.abs(card.getBoundingClientRect().left - trackRect.left);
          if (distance < best) {
            best = distance;
            index = i;
          }
        });
        this.dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      disconnectedCallback() {
        this.ready = false;
        this.track?.removeEventListener('scroll', this.onScroll);
      }
    }

    customElements.define('home-need-cards', HomeNeedCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-product-float"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-float-slides')) {
    class HomeFloatSlides extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.go(index);
            this.restart();
          });
        });
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        document.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-slide]');
          if (!slide || !this.contains(slide)) return;
          const index = this.slides.indexOf(slide);
          if (index >= 0) this.go(index);
          this.stop();
        });
        this.start();
      }

      go(index) {
        this.index = index;
        this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        this.dots.forEach((dot, i) => {
          const on = i === index;
          dot.classList.toggle('is-active', on);
          dot.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      start() {
        if (this.dataset.autoplay !== 'true') return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stop();
        const seconds = Number(this.dataset.interval) || 6;
        this.timer = window.setInterval(() => {
          this.go((this.index + 1) % this.slides.length);
        }, seconds * 1000);
      }

      stop() {
        window.clearInterval(this.timer);
      }

      restart() {
        this.stop();
        this.start();
      }
    }

    customElements.define('home-float-slides', HomeFloatSlides);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-product-posters"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-scroll-row')) {
    class HomeScrollRow extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.track = this.querySelector('[data-track]');
        this.prevButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');
        this.controls = this.querySelector('[data-controls]');
        if (!this.track) return;

        this.onPrev = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.onScroll = () => this.sync();
        this.prevButton?.addEventListener('click', this.onPrev);
        this.nextButton?.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.sync();
      }

      move(direction) {
        const card = this.track.querySelector('[data-card]');
        if (!card) return;
        const styles = getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 16;
        const amount = card.getBoundingClientRect().width + gap;
        this.track.scrollTo({
          left: this.track.scrollLeft + amount * direction,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      sync() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const overflows = max > 4;
        if (this.controls) this.controls.hidden = !overflows;
        if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 4;
        if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= max - 4;
      }

      disconnectedCallback() {
        this.ready = false;
        this.prevButton?.removeEventListener('click', this.onPrev);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.track?.removeEventListener('scroll', this.onScroll);
      }
    }

    customElements.define('home-scroll-row', HomeScrollRow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-product-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-scroll-row')) {
    class HomeScrollRow extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.track = this.querySelector('[data-track]');
        this.prevButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');
        this.controls = this.querySelector('[data-controls]');
        if (!this.track) return;

        this.onPrev = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.onScroll = () => this.sync();
        this.prevButton?.addEventListener('click', this.onPrev);
        this.nextButton?.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.sync();
      }

      move(direction) {
        const card = this.track.querySelector('[data-card]');
        if (!card) return;
        const styles = getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 16;
        const amount = card.getBoundingClientRect().width + gap;
        this.track.scrollTo({
          left: this.track.scrollLeft + amount * direction,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      sync() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const overflows = max > 4;
        if (this.controls) this.controls.hidden = !overflows;
        if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 4;
        if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= max - 4;
      }

      disconnectedCallback() {
        this.ready = false;
        this.prevButton?.removeEventListener('click', this.onPrev);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.track?.removeEventListener('scroll', this.onScroll);
      }
    }

    customElements.define('home-scroll-row', HomeScrollRow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
